const h=["p","h1","h2","h3","h4","h5","h6","a","li","strong","em","u","del","sup","sub"];export{h as VALID_TAGS};
//# sourceMappingURL=constants.js.map
